<template>
    <div class="w-full section-wrapper text-base mx-4 mb-16">
        <div class="w-full flex flex-wrap justify-between mb-10">
            <div class="panel w-full md:w-1/3">
                <div class="sticky top-4">


                <div class="panel">
                    <Link href="/shows" class="header-class header-link"><vue-feather type="music" size="20px" class="-mb-[2px]" aria-hidden="true" /> Next Show</Link>
                    <ShowObject v-if="nextShow" class="block w-full" :show="nextShow" />
                    <div v-else class="w-full md:w-1/3 flex flex-wrap justify-center items-center">
                        No Upcoming Show. Check Back Soon!
                    </div>
                </div>
                <div class="panel">
                    <Standings gender="men" :standings="standingsMen" />
                    <Standings gender="women" :standings="standingsWomen" />

                </div>
                </div>
            </div>
            <div class="panel w-full md:w-1/3 mt-2 px-4">
                <Link class="header-class header-link" href="/birds"><vue-feather type="twitter" size="20px" class="-mb-[2px] mr-1" aria-hidden="true" /> Today's Visiting Birds</Link>
                <BirdsLatest :birds="latestBirds.slice(0,7)" :trigger="trigger"/>
            </div>
            <div class="panel w-full md:w-1/3 pl-4">
                <div class="sticky top-4 left-0">

                    <Link class="header-class header-link" href="/television">
                        <vue-feather type="tv" size="20px" class="-mb-[2px]" aria-hidden="true" />
                        Upcoming TV Shows
                    </Link>
                    <TelevisionUpcomingShows class="mt-4" :count="4" :shows="tv" :assetsPath="assetsPath"  />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import BirdsLatest from '@/Components/BirdsLatest.vue';
import TelevisionUpcomingShows from '@/Components/TelevisionUpcomingShows.vue';
import GuestLayout from '../Layouts/GuestLayout.vue';
import ShowObject from '@/Components/ShowObject.vue';
import { Link } from '@inertiajs/vue3'
import { urlify } from '@/utils/Utilities';
import { gsap } from "gsap/all";
import { mapWritableState } from 'pinia';
import { useGeneralStore } from '@/utils/useGeneralStore';
import BasketballStandings from '@/Components/BasketballStandings.vue';
import * as DataService from '../DataService.js'

    export default {
        layout: GuestLayout,
        name: "HomeBar",
        components: { BirdsLatest, Link, ShowObject, TelevisionUpcomingShows, Standings: BasketballStandings },
        computed: {
            ...mapWritableState(useGeneralStore, ['latestBirds'])
        },
        props: ['foo', 'tv', 'birds', 'shows', 'standingsMen', 'standingsWomen', 'assetsPath'],
        data() {
            return {
                nextShow: null,
                trigger: false
            }
        },
        unmounted() {
            this.trigger=false;
        },
        mounted() {
            this.nextShow=this.shows[0];
            gsap.to('.panel', {opacity: 1, stagger: .2, duration: .3, onComplete: () => {
                this.trigger=true;
            }})
            this.latestBirds=this.birds;

        },
        methods: {
            urlify
        }
    }
</script>

<style lang="postcss">
.panel {
    opacity:0;

}
</style>
